export const DateFormatString = "M/D/YYYY";

export const ExtraordinaryCircumstancesQuarters = [
    "20202", // Spring 2020
    "20203", // Summer 2020
    "20204", // Autumn 2020
    "20211", // Winter 2021
    "20212", // Spring 2021
    "20213", // Summer 2021
    "20221"  // Winter 2022
];

// this block is duplicated in plan-app-api Constants.js
export const NextAction = Object.freeze({
    REG_SVCS_NOT_OPEN: 'reg_svcs_not_open', // Registration services haven't opened yet, for anybody
    ACKNOWLEDGE: 'acknowledge',
    ADDRESS: 'address',
    PREREG: 'prereg',
    BLOCK: 'block',
    STUDENT_REG_NOT_OPEN: 'student_reg_not_open', // This student's registration period hasn't opened yet
    REGISTER: 'register',
    SUCCESS: 'success',
    FAIL: 'fail'
});

export const PlanItemType = Object.freeze({
    registered: "registered",
    planned: "planned",
    backup: "backup",
    recommended: "recommended"
});

export const PlanViewType = Object.freeze({
    plan: "plan",
    reg: "reg"
})